import { IpSetIP, IpSetListInterface } from '@/services/IPSet/Interfaces';

export default class IpSetList implements IpSetListInterface {
  constructor(
    public name: string,
    public type: string,
    public timeoutSupport: boolean,
    public defaultTimeout: number|undefined,
    public commentsSupport: boolean,
    public counters: boolean,
    public skbInfo?: boolean,
    public hashSize?: number,
    public maxElements?: number,
  ) {}
}
